// src/app/AppThemeProvider.tsx
import React, { type ReactNode } from 'react';
import {MantineProvider, MantineTheme} from '@mantine/core';
import '@mantine/core/styles.css';
import '@/assets/scss/style.scss';
import {resolver, theme} from "@/theme";

type ColorTuple = [string, string, string, string, string, string, string, string, string, string];

const brand: ColorTuple = [
    '#eaf3f8', // 0
    '#d6e8f2', // 1
    '#b7d7e8', // 2
    '#94c2db', // 3
    '#72adce', // 4
    '#4f98c1', // 5
    '#1E6A98', // 6
    '#17577c', // 7
    '#11425e', // 8
    '#0a2c3f', // 9
];

type AppThemeProviderProps = {
    children: ReactNode;
};

export const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children }) => {
    return (
        <MantineProvider
            defaultColorScheme="dark"
            theme={theme}
            cssVariablesResolver={resolver}
        >
            {children}
        </MantineProvider>
    );
};
